/**
 * Post Shared Preview Utils
 *
 * Shared helpers for cleaning preview HTML and extracting OGP/SNS content.
 */

import { Patterns } from "../../constants/patterns";
import { OgpPreviewHandler } from "../../util/ogp/ogp-preview-handler";

interface CleanPreviewHtmlParams {
    html: string;
    snsUrls: string[];
}

class PostSharedPreviewContentUtils {
    public static detectOgpUrlsFromHtml(html: string): string[] {
        const ogpPreview = new OgpPreviewHandler();
        if (!ogpPreview.ogpRender || typeof ogpPreview.ogpRender.detectUrls !== "function") {
            return [];
        }

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html || "";
        return ogpPreview.ogpRender.detectUrls(tempDiv.textContent || "");
    }

    public static stripEmbedsAndUrlsFromPreviewHtml(html: string, snsUrls: string[], ogpUrls: string[]): string {
        let out = String(html ?? "");

        for (let index = 0; index < 3; index++) {
            out = out.replace(Patterns.reset(Patterns.ESCAPED_IFRAME_STRIP), "");
            out = out.replace(Patterns.reset(Patterns.ESCAPED_IFRAME_STRIP_ALT), "");
        }

        out = out.replace(Patterns.reset(Patterns.IFRAME_TAG), "");
        out = out.replace(Patterns.reset(Patterns.IFRAME_SELF_CLOSING), "");
        out = out.replace(Patterns.reset(Patterns.PARAGRAPH_WITH_ESCAPED_IFRAME), "");
        out = out.replace(Patterns.reset(Patterns.PARAGRAPH_WITH_IFRAME), "");

        (snsUrls || []).forEach((url) => {
            out = out.replace(Patterns.createUrlInParagraphPattern(url), "");
            out = out.replace(Patterns.createPlainUrlPattern(url), "");
        });

        (ogpUrls || []).forEach((url) => {
            out = out.replace(Patterns.createUrlInParagraphPattern(url), "");
            out = out.replace(Patterns.createPlainUrlPattern(url), "");
        });

        out = out.replace(/<p>\s*<\/p>/gi, "");
        out = out.replace(/<p>\s*<br>\s*<\/p>/gi, "");
        out = out.replace(/<p><\/p>/gi, "");

        return out;
    }

    public static buildCleanPreviewHtml(params: CleanPreviewHtmlParams): string {
        const { html, snsUrls } = params;

        const stage1 = PostSharedPreviewContentUtils.stripEmbedsAndUrlsFromPreviewHtml(html, snsUrls, []);
        const ogpUrls = PostSharedPreviewContentUtils.detectOgpUrlsFromHtml(stage1);
        return PostSharedPreviewContentUtils.stripEmbedsAndUrlsFromPreviewHtml(stage1, [], ogpUrls);
    }
}

export { PostSharedPreviewContentUtils };
